import { Pipe, PipeTransform } from '@angular/core';
import { abbreviate } from '../utils';

@Pipe({ name: 'abbreviate', standalone: true })
export class AbbreviatePipe implements PipeTransform {
  transform(value: unknown, max?: number): unknown {
    return typeof value === 'string' ? abbreviate(value, max) : value;
  }
}
